import * as React from 'react'
import { supabase } from './supabase'
import { Button, Dialog } from './ui'
import { BookingAssignmentDialog, type AssignmentBooking } from './BookingAssignmentDialog'

// Read the current booking when Assign is clicked, so the existing assignment
// dialog uses fresh payment, quantity, collection-date and concurrency details.
export function BookingAssignmentPortal({ bookingId, onClose, onSaved }: {
  bookingId: string; onClose: () => void; onSaved: () => Promise<void>
}) {
  const [booking, setBooking] = React.useState<AssignmentBooking | null>(null)
  const [error, setError] = React.useState('')
  const [revision, setRevision] = React.useState(0)
  React.useEffect(() => {
    let live = true
    setBooking(null)
    setError('')
    const load = async () => {
      try {
        const { data, error } = await supabase.from('bookings')
          .select('id,state,booking_reference,customer_name,customer_email,delivery_date,operational_delivery_date,collection_date,operational_collection_date,quantity,updated_at,payment_state,assignment_mode,products(name,sku,product_types(assignment_mode))')
          .eq('id', bookingId).maybeSingle()
        if (!live) return
        if (error) throw error
        if (!data) throw new Error('This booking could not be found.')
        if (data.state !== 'unassigned') throw new Error('This booking no longer needs assignment. Close this dialog to return to Bookings.')
        setBooking(data as unknown as AssignmentBooking)
      } catch (error) {
        if (live) setError(error && typeof error === 'object' && 'message' in error ? String(error.message) : 'Could not load the booking.')
      }
    }
    void load()
    return () => { live = false }
  }, [bookingId, revision])

  if (booking) return <BookingAssignmentDialog booking={booking} onClose={onClose} onSaved={onSaved} />
  return <Dialog isOpen onOpenChange={open => { if (!open) onClose() }} width="min(700px, 96vw)"><div className="ops-dialog">
    <h2>Assign equipment</h2>
    {error ? <p className="message error" role="alert">{error}</p> : <p role="status">Loading booking…</p>}
    <div className="ops-actions"><Button type="button" onClick={onClose}>Close</Button>{error && <Button type="button" onClick={() => setRevision(value => value + 1)}>Retry</Button>}</div>
  </div></Dialog>
}
